import styled from 'styled-components';
export var Value = styled.div.withConfig({
  displayName: "partials__Value",
  componentId: "sc-11h78ur-0"
})(["display:", ";"], function (_ref) {
  var inline = _ref.inline;
  return inline ? 'inline' : 'block';
});